<body>
    <div class="imprint_container" id="#imprint_link">
        <div class='content'>
            <h1 id="imprintTitle">Impressum</h1>
            <p id="informationAccording">Angaben gemäß § 5 DDG</p>
            <p>Sangeethan<br>
            </p>
            <p>
                <strong id="representedBy">Vertreten durch:</strong><br>
                <span>Sangeethan</span><br>
            </p>
            <p>
                <strong id="contactImprint">Kontakt:</strong> <br>
                <span id="telephone">Telefon:</span> <br>
                E-Mail: <a href='mailto:contact@.com'>contact&#64;</a><br>
            </p>
        </div>
    </div>

</body>